import Cookies from "js-cookie";
import logo from "src/assets/logo.png";
import { Box, Modal } from "@mui/material";
import { RxCrossCircled } from "react-icons/rx";
import React, { useContext, useState } from "react";
import CoachAvatar from "src/components/atoms/CoachAvatar";
import { MyContext } from "src/components/Context/MyContext";
import loaderAnimation from "src/assets/loaderAnimation.gif";
import PrimaryButton from "src/components/atoms/buttons/PrimaryButton";
import CONSTANTS from "src/components/services/api";
const AppHeader = ({ children, loading }) => {
  const coachName = Cookies.get("name");
  const { userInfo,userId } = useContext(MyContext);
  const profile_pic = Cookies.get("profile_pic");
  const userProfilePic = profile_pic || userInfo?.pro_pic_url;

  const [openUserProfile, setOpenUserProfile] = useState(false);

  const openImage = () => {
    setOpenUserProfile(true);
  };

  const logoutClick = () => {
    Cookies.remove("Token");
    Cookies.remove("roleId");
    Cookies.remove("name");
    Cookies.remove("profile_pic");
    Cookies.remove("user_id", { path: "/" });
    Cookies.remove("user_id", { path: "/", domain: "imwow.co.in" });
    Cookies.remove("user_id", { path: "/", domain: ".imwow.co.in" });
    // localStorage.removeItem("my-user-id");
    deleteCookie("user_id");
    window.location.reload();
  };

  function deleteCookie(name) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict`;
    document.cookie = `${name}=; domain=imwow.co.in; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict`;
    document.cookie = `${name}=; domain=.imwow.co.in; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict`;
  }

  return (
    <>
      <div className="w-full bg-white h-[10rem] md:h-[60px] px-4 sticky right-0 top-0  border-blue-gray-100 border-2">
        <div className="flex justify-between items-center h-full">
          <div className="flex items-center md:space-x-6 flex-col md:flex-row">
            <img src={logo} alt="" className="h-[46px]" />
            {coachName == null && userId ? (
              <div className="flex justify-center items-center">
                <img src={loaderAnimation} alt="loader" />
              </div>
            ) : (
              userId && <CoachAvatar avHeight="46px" radius="full" title={coachName} headingCss="w-[8rem]" imgUrl={userProfilePic} openImage={openImage} />
            )}
            <PrimaryButton
              title="Dashboard"
              css="!px-3 !py-2 rounded text-sm font-medium hover:bg-[#6ede7b]"
              handler={() => window.open(`${CONSTANTS.DASHBOARD_BASE}/imwow/dashboard`, "_self")}
            />
          </div>
          {userId && (
            <button className="text-[14px] font-semibold mr-5 cursor-pointer " onClick={() => logoutClick()}>
              Logout
            </button>
          )}
          {children}
        </div>
      </div>
      {openUserProfile ? (
        <Modal
          open={openUserProfile}
          onClose={() => setOpenUserProfile(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <RxCrossCircled
              size={30}
              className="absolute right-2 top-2 cursor-pointer bg-gray-200 rounded-full"
              onClick={() => {
                setOpenUserProfile(false);
              }}
            />
            <img src={userProfilePic} className="rounded-full object-cover h-[500px] w-[500px]" />
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default AppHeader;
